import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlockLifemapComponent } from './block-lifemap.component';
import { LifeActModule } from '@app/components/lifeAct/lifeAct.module';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { PlTimepickerModule } from '@app/components/pl-timepicker/pl-timepicker.module';
import { PlInputModule } from '@app/components/pl-input/pl-input.module';
import { ButtonModule } from '@app/components/button/button.module';
import { EditLifemapEntryModule } from '@app/components/blocks/block-lifemap/editLifemapEntry/editLifemapEntry.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalConfirmEventsOverrideModule } from '@app/components/blocks/block-lifemap/modalConfirmEventsOverride/modalConfirmEventsOverride.module';
import { ModalSleepHoursModule } from '@app/components/blocks/block-lifemap/modalSleepHours/modalSleepHours.module';
import { EventDurationPipeModule } from '@app/components/blocks/block-lifemap/pipes/eventDuration.pipe.module';
import { ModalEditLifemapEntryModule } from '@app/components/blocks/block-lifemap/modalEditLifemapEntry/modalEditLifemapEntry.module';
import { CalendarViewHourDisplayPipeModule } from '@app/components/blocks/block-lifemap/pipes/calendarViewHourDisplay/calendarViewHourDisplay.pipe.module';
import { ModalLifemapCompletedModule } from '@app/components/blocks/block-lifemap/modalLifemapCompleted/modalLifemapCompleted.module';
import { BlockHtmlModule } from '@app/components/blocks/block-html/block-html.module';
import { LifemapHelpModule } from '@app/components/blocks/block-lifemap/lifemapHelp/lifemapHelp.module';

@NgModule({
  imports: [
    ButtonModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    CalendarViewHourDisplayPipeModule,
    CommonModule,
    EditLifemapEntryModule,
    EventDurationPipeModule,
    FormsModule,
    LifeActModule,
    MatDialogModule,
    ModalConfirmEventsOverrideModule,
    ModalEditLifemapEntryModule,
    ModalLifemapCompletedModule,
    ModalSleepHoursModule,
    NgOptimizedImage,
    PlIconModule,
    PlInputModule,
    PlTimepickerModule,
    ReactiveFormsModule,
    SharedModule,
    BlockHtmlModule,
    LifemapHelpModule,
  ],
  declarations: [BlockLifemapComponent],
  exports: [BlockLifemapComponent],
})
export class BlockLifemapModule {}
